"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _react = _interopRequireWildcard(require("react"));
var _formatSpecialCharText = _interopRequireDefault(require("../../utils/formatSpecialCharText"));
var _useScreenSize = require("../../utils/hooks/useScreenSize");
require("./ProductsPackage.scss");
var _ProductsPackageMethods = require("./ProductsPackageMethods");
var _Button = _interopRequireDefault(require("../Button/Button"));
var _Image = _interopRequireDefault(require("../Image/Image"));
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function (nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }
function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || typeof obj !== "object" && typeof obj !== "function") { return { default: obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj.default = obj; if (cache) { cache.set(obj, newObj); } return newObj; }
const ProductsPackage = _ref => {
  let {
    content,
    contentfulId
  } = _ref;
  const [heightOfTallestCard, setHeightOfTallestCard] = (0, _react.useState)(575);
  const {
    eyebrow,
    header,
    text,
    productEyebrow,
    cards,
    image,
    cta
  } = content;
  const {
    width
  } = (0, _useScreenSize.useScreenSize)();
  const packageWrapper = (0, _react.useRef)(null);
  (0, _react.useEffect)(() => {
    if (typeof document !== undefined) {
      const cards = document?.querySelectorAll(".ter-bounded-card");
      //Transform a NodeList to array
      const cardsArry = Array?.prototype?.slice?.call(cards);
      //Put all heights into an array
      const cardsHeight = cardsArry?.map(card => {
        return card?.clientHeight;
      });
      //Find the tallest card's height
      const tallestCard = cardsHeight && cardsHeight?.length ? Math.max(...cardsHeight) : null;
      //add all heights of cards to find the total height for mobile

      const startingValue = 0;
      const mobileHeight = cardsHeight?.reduce((previousValue, currentValue) => previousValue + currentValue, startingValue);
      if (cards?.length >= 4 && tallestCard > 575 && width > 600 && width !== 0) {
        setHeightOfTallestCard(tallestCard + 70);
      } else if (cards?.length <= 3 && tallestCard > 575 && width > 600 && width !== 0) {
        setHeightOfTallestCard(tallestCard + 20);
      } else if (width <= 600 && width !== 0) {
        setHeightOfTallestCard(mobileHeight + document?.querySelector(".mxp-products-package-container__right-section")?.clientHeight);
      } else {
        setHeightOfTallestCard(575);
      }
      (0, _ProductsPackageMethods.addCardMargin)(packageWrapper?.current, width);
    }
  }, [width]);
  return /*#__PURE__*/_react.default.createElement("section", {
    className: "mxp-products-package",
    ref: packageWrapper
  }, /*#__PURE__*/_react.default.createElement("div", {
    className: "mxp-products-package-container",
    "data-sb-object-id": contentfulId && contentfulId
  }, /*#__PURE__*/_react.default.createElement("div", {
    className: "mxp-products-package-container__right-section"
  }, /*#__PURE__*/_react.default.createElement("section", {
    className: "mxp-products-package-container__right-section--text-area"
  }, eyebrow && /*#__PURE__*/_react.default.createElement("h2", {
    className: "mxp-products-package-container__right-section--eyebrow",
    "data-sb-field-path": "eyebrow"
  }, eyebrow), header && /*#__PURE__*/_react.default.createElement("h3", {
    className: "mxp-products-package-container__right-section--header",
    dangerouslySetInnerHTML: (0, _formatSpecialCharText.default)(header),
    "data-sb-field-path": "header"
  }), text && /*#__PURE__*/_react.default.createElement("p", {
    className: "mxp-products-package-container__right-section--text",
    dangerouslySetInnerHTML: (0, _formatSpecialCharText.default)(text),
    "data-sb-field-path": "text"
  }), cta && /*#__PURE__*/_react.default.createElement(_Button.default, {
    Link: cta?.Link,
    text: cta?.text,
    url: cta?.url,
    onClick: cta?.onClick,
    className: cta?.className || "ter-button--primary--1",
    contentfulId: cta?.contentfulId
  })), /*#__PURE__*/_react.default.createElement("div", {
    className: "mxp-products-package-container__right-section--image-container"
  }, image && /*#__PURE__*/_react.default.createElement(_Image.default, {
    className: "mxp-products-package-container__right-section--image",
    src: image?.url,
    alt: image?.alt,
    contentfulId: image?.contentfulId
  }))), /*#__PURE__*/_react.default.createElement("div", {
    className: "mxp-products-package-container__left-section"
  }, productEyebrow && /*#__PURE__*/_react.default.createElement("h2", {
    className: "mxp-products-package-container__left-section--eyebrow",
    "data-sb-field-path": "productEyebrow"
  }, productEyebrow), /*#__PURE__*/_react.default.createElement("section", {
    className: "mxp-products-package-container__left-section--card-container",
    style: cards?.length >= 3 && width >= "600" ? {
      maxHeight: heightOfTallestCard,
      flexDirection: "row",
      flexWrap: "wrap",
      overflowY: "scroll"
    } : cards?.length >= 3 && width < "600" ? {
      maxHeight: heightOfTallestCard
    } : {
      maxHeight: "595px"
    },
    "data-sb-field-path": "productCards"
  }, (0, _ProductsPackageMethods.formatCards)(cards)))));
};
var _default = ProductsPackage;
exports.default = _default;